module.exports = __webpack_public_path__ + "img/x-square.ecb4f252.svg";